import chatModule from '@chat/module/store/type'
import _ from "lodash";
import { conversationsFullyScrolled, scrollToLastMessage } from '@chat/lib/helpers';

export default e => {
        console.log('[New Message Typing Listener]', e);
        let typeData = e.typeEvent;
        // Update or unshift conversation
        store.commit(chatModule.mutations.conversations.addTyping, {
                user_id: typeData.user_typed,
                event_id : typeData.event_id
        })
        let chatType = !typeData.event_id ? 'user' : 'event';

        const wasAtBottom = conversationsFullyScrolled(chatType);
        if (wasAtBottom) {
                setTimeout(() => {
                        scrollToLastMessage(chatType);
                }, 50)
        }
}